import { createApp } from 'vue';
import router from '@/router';
import { store } from '@/store';
import App from '@/App.vue';
import 'windi.css';
import 'prismjs';
import 'prismjs/themes/prism.css';
// Setup Datepicker
// import VCalendar from 'v-calendar'
// import 'v-calendar/dist/style.css'
// Setup FontAwesome Icons
import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
library.add(fas);
library.add(far);
library.add(fab);
dom.watch();
const app = createApp(App);
//app.use(VCalendar)
app.use(store);
app.use(router).component('font-awesome-icon', FontAwesomeIcon).mount('#app');
